import { createApp } from 'vue'

import CustomerForm from '@/src/javascripts/settings/customers/CustomerForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const customerForm = document.querySelector('#customer-form')
  if (customerForm && !customerForm.__vue_app__) {
    createApp({ components: { CustomerForm, BaseAlert } }).mount(customerForm)
  }
})
